<template>
  <div class="mob-filters">
    <div class="mob-filters__wrap">
      <div class="mob-filters__head">
        <h2 class="section-title">Filters</h2>
        <svg @click="$emit('close')">
          <use xlink:href="#times-light"></use>
        </svg>
      </div>
      <div class="mob-filters__body">
        <MobSingleFilter
           v-for="(value, key) in filters"
          :key="key"
          :title="key"
          :filter="value"
        />
        <div class="mob-filters__btn-wrap">
          <div @click="clearFilters" class="main-btn">Clear Filters</div>
          <div @click="$emit('close')" class="main-btn main-btn--gray">Close</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MobSingleFilter from "./MobSingleFilter.vue";
export default {
  name: "MobFilters",
  components: { MobSingleFilter },
  computed: {
    ...mapState("products", ["filters"]),
  },
  methods: {
    ...mapActions("products", ["resetProducts"]),
    clearFilters(){
      this.resetProducts()
      this.$emit('close')
    }
  },

};
</script>
